<template>
    <div v-if="additionals && additionals.salaVacinacao.id">
        <rkm-form
            ref="Form"
            show-legend
            v-if="model && form"
        >
            <rkm-area
                type="fieldset"
                title="Cadastro"
            >
                <rkm-row>
                    <rkm-col>
                        <rkm-form-input-autocomplete
                            :repository="repositories.usuario"
                            :requestQueryStringParams="autocompleteRequestParams.usuario"
                            :searchFields="searchFields.autocomplete.usuario"
                            label="Profissional"
                            placeholder="Digite o nome ou número do conselho profissional"
                            uppercase
                            v-model="model.usuario"
                            :validations="validations.usuario"
                            :text-field="(item) =>  item.cidadaoCns ? `${this.formatCns(item.cidadaoCns)} - ${item.cidadaoNome}` : item.cidadaoNome"
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-form-select
                            label="Unidade"
                            :options="form.unidades"
                            show-default-option
                            default-option-text="Selecione"
                            v-model="model.unidadeId"
                            value-field="id"
                            text-field="nomeFantasia"
                            :validations="validations.unidade"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            :options="infraestruturas"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            :validations="validations.infraestrutura"
                            default-option-text="Selecione"
                            value-field="id"
                            :disabled="model.unidadeId == null"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-select
                            label="Ocupação"
                            :options="form.ocupacoes"
                            v-model="model.ocupacaoId"
                            :validations="validations.ocupacao"
                            text-field="codigoNome"
                            value-field="id"
                            show-default-option
                            default-option-text="Selecione"
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-form-select
                            label="Equipe"
                            :options="form.equipes"
                            v-model="model.equipeId"
                            :validations="validations.equipe"
                            text-field="descricao"
                            value-field="id"
                            show-default-option
                            default-option-text="Selecione"
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-form-date-picker
                            label="Data a aplicação"
                            v-model="model.data"
                            :validations="validations.data"
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-button
                            color="primary"
                            :label="false"
                            @click="add"
                        >
                            Adicionar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-form>

        <rkm-area
            type="fieldset"
            title="Vacinações individualizadas"
            v-if="items.length"
        >
            <rkm-table
                :items="items"
                :fields="fields"
                hide-pagination
                hide-filters
                no-footer-sorting
            >
                <template v-slot:cell(actions)>
                    <rkm-button
                        color=danger
                        title="Excluir"
                        small
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-area>

        <Modal
            ref="Modal"
            :model="model"
            :form="form"
            :additionals="additionals"
        />
    </div>

    <rkm-alert v-else color="warning">
        A unidade logada não é uma sala de vacinação, favor cadastrá-la para efetuar um registro de vacinação.
    </rkm-alert>
</template>

<script>
import permissao from '@/enums/atencao-basica/parametrizacao/permissao'
import Modal from '@/components/atencao-basica/ficha-vacinacao/Modal'
import { repository, error, formats } from '@/mixins';
import { mapActions } from "vuex";

export default {
    components: {
        Modal
    },
    created() {
        this.repositories = {
            fichaVacinacao: this.getConectaSusRepository('atencaoBasica.fichaVacinacao'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
        }
        this.load()
    },
    computed: {
        validations() {
            return {
                unidade: {
                    required: true
                },
                usuario: {
                    required: true
                },
                ocupacao: {
                    required: true
                },
                equipe: {
                    required: true
                },
                data: {
                    required: true
                }
            }
        },
        autocompleteRequestParams() {
            return {
                usuario: {
                    with_not_regularized: true,
                    with_atencao_basica_equipe: true,
                    with_atencao_basica_permissao: this.enums.permissao.FICHA_DE_VACINACAO,
                }
            }
        },
        searchFields() {
            return {
                autocomplete: {
                    usuario: [
                        { key: "cadastroCidadao.nome", searchable: true },
                        { key: "cadastroUsuario.registroNumero", searchable: true },
                    ]
                }
            }
        },
        fields() {
            return [
                {
                    key: "prontuario",
                    label: "Prontuário",
                    fixed: true
                },
                {
                    key: "paciente",
                    label: "Paciente",
                    fixed: true
                },
                {
                    key: "cns",
                    label: "CNS",
                    fixed: true
                },
                {
                    key: "dataNascimento",
                    label: "Data de nascimento",
                    fixed: true
                },
                {
                    key: "sexo",
                    label: "Sexo",
                    fixed: true
                },
                {
                    key: "turno",
                    label: "Turno",
                    fixed: true
                },
                {
                    name: 'actions',
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        }
    },
    data() {
        return {
            items: [],
            model: null,
            form: null,
            additionals: null,
            enums: {
                permissao
            },
            unidades: [],
            infraestruturas: [],
            equipes: []
        }
    },
    methods: {
        ...mapActions(["setLoading", "unsetLoading"]),
        load() {
            this.setLoading()
            this.repositories.fichaVacinacao.create()
                .then(({ data }) => {
                    if(data.model) {
                        this.model = data.model
                    }
                    if(data.form) {
                        this.form = data.form
                    }
                    if(data.additionals) {
                        this.additionals = data.additionals
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getUnidades() {
            this.setLoading()
            this.repositories.fichaVacinacao.getUnidades({
                usuario_id: this.model.usuario.id
            })
                .then(({ data }) => {
                    this.form.unidades = data
                    if(data.length == 1) {
                        this.model.unidadeId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getInfraestruturas() {
            this.setLoading()
            this.repositories.fichaVacinacao.getInfraestruturas({
                unidade_id: this.model.unidadeId
            })
                .then(({ data }) => {
                    this.infraestruturas = data
                    if(data.length == 1) {
                        this.model.infraestruturaId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getEquipes() {
            this.setLoading()
            this.repositories.fichaVacinacao.getEquipes({
                usuario_id: this.model.usuario.id,
                infraestrutura_id: this.model.infraestruturaId
            })
                .then(({ data }) => {
                    this.form.equipes = data
                    if(data.length == 1) {
                        this.model.equipeId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getOcupacoes() {
            this.setLoading()
            this.repositories.fichaVacinacao.getOcupacoes({
                usuario_id: this.model.usuario.id,
                infraestrutura_id: this.model.infraestruturaId
            })
                .then(({ data }) => {
                    this.form.ocupacoes = data
                    if(data.length == 1) {
                        this.model.ocupacaoId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        add() {
            this.$refs.Form.validate()
                .then(valid => {
                    if(!valid) return

                    this.$refs.Modal.open()
                })
        }
    },
    watch: {
        'model.usuario': function (usuario) {
            if(usuario) {
                this.getUnidades()
            }
        },
        'model.unidadeId': function (unidadeId) {
            if(unidadeId) {
                this.getInfraestruturas()
            }
        },
        'model.infraestruturaId': function(infraestruturaId) {
            if(infraestruturaId) {
                this.getOcupacoes()
                this.getEquipes()
            }
        }
    },
    mixins: [ repository, error, formats ]
}
</script>